module.exports = __webpack_public_path__ + "img/notice-sub1.1e0b0541.png";